import axios from "axios";
import {API_URL, APP_URL} from "../config";
import jsonToFormData from "json-form-data";

export const storeProductService = async (values) => {

    let options = {
        initialFormData: new FormData(),
        showLeafArrayIndexes: true,
        includeNullValues: true
    };

    let data = {...values};

    const formData = jsonToFormData(data, options);

    return axios.post(`${API_URL}/products`, formData);
};

export const updateProductService = async (id, values) => {

    let options = {
        initialFormData: new FormData(),
        showLeafArrayIndexes: true,
        includeNullValues: true
    };

    let data = {...values};

    data._method = 'PUT';

    if(typeof data.image_name === 'string')
        delete data.image_name;

    const formData = jsonToFormData(data, options);

    return axios.post(`${API_URL}/products/${id}`, formData);
};

export const getProductService = async (id) => {
    return axios.get(`${API_URL}/products/${id}`);
}

export const listProductsService = async (params) => {
    return axios.get(`${API_URL}/products`, {
        params: {
            ...params
        }
    });
}
